module.exports = __webpack_public_path__ + "img/4.0dcb7e3b.png";